// Single source of truth for headline platform stats.
// Update these if the course/quiz catalogue changes (backend FINANCIAL_COURSES / QUIZ_QUESTIONS).
export const STATS = {
  courses: 67,
  lessons: 112,
  quizzes: 193,
};

// Display-ready stat tiles for the landing page (accurate, no "free"/"R0" implications).
export const STAT_TILES = [
  [`${STATS.courses}`, 'Structured Courses'],
  [`${STATS.lessons}`, 'Lessons'],
  [`${STATS.quizzes}`, 'Quizzes'],
  ['24/7', 'AI Money Coach'],
];
